import type { Action, Resource } from '@/constants/permissions'
import { useAuthStore } from '@/store/auth.store'
import { hasPermission } from '@/utils/permission'

/**
 * Returns whether the current user holds `${resource}:${action}` (or a
 * `${resource}:manage` superpower). Reactive — re-renders when the user changes.
 */
export function usePermission(resource: Resource, action: Action): boolean {
  const permissions = useAuthStore((s) => s.user?.permissions)
  return hasPermission(permissions ?? [], resource, action)
}
